import * as React from 'react';
import { cloneDeep, flow, get, last } from 'lodash';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { destroy, reduxForm, reset } from 'redux-form';
import { IMtaFormNames } from '../../../../../../services/mta/models';
import { mtaActions } from '../../../../../../services/mta/actions';
import Loading from '../../../../../../components/Loading';
import { withJob } from 'react-jobs';
import { actions as brandingActions } from '../../../../../../services/branding/reducer';
import { RedirectCommon } from '../RedirectCommon';

class RedirectToMtaRegion extends RedirectCommon  {

  componentDidMount() {
    super.componentDidMount('change_region.enabled')
    this.checkErrors('/account/make-a-change/mta/change-region');
  }

  public render() {
    const { mta } = this.props;
    const { loading, allowedMta } = this.state;

    if (mta.isLoading || loading) {
      return (
        <Loading/>
      )
    }

    if (!allowedMta && !loading) {
      return this.renderNotAllowedMta();
    }

    return (
      <Loading/>
    )
  }
}

export default flow([
  withJob({
    work: (props: any) => {
      const promises = [];

      promises.push(props.actions.branding.reLoadChannel(props.branding.defaultChannelKey));

      return Promise.all(promises);
    },
    LoadingComponent: (props) => <Loading/>,
    ErrorComponent: ({ error }) => {

      return (
        <div>
          {error.message}
        </div>
      );
    },
  }),
  reduxForm({
    form: IMtaFormNames.COVER_DETAILS,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    return component;
  },
  connect(
    (state: IStore) => {
      const mtaPolicy = cloneDeep(state.mta.selectedPolicy);
      const latestPremium = last(mtaPolicy.premiums);
      mtaPolicy.effective_date = new Date();
      mtaPolicy.mta = true;
      mtaPolicy.scheme_id = latestPremium ? latestPremium.scheme.id : null;
      return {
        mtaPolicy,
        auth: state.auth,
        mta: state.mta,
        branding: state.branding,
        customerMTAOptions: get(state.branding.channel.products[0], 'metadata.direct_customer_mta_options', null),
      };
    },
    (dispatch) => ({
      actions: {
        dispatch,
        push: bindActionCreators(push, dispatch),
        reset: bindActionCreators(reset, dispatch),
        destroy: bindActionCreators(destroy, dispatch),
        mta: bindActionCreators({ ...mtaActions }, dispatch),
        branding: bindActionCreators({ ...brandingActions }, dispatch),
      },
    }),
  ),
])(RedirectToMtaRegion);
